import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

import { map, take } from 'rxjs';

import { UserPermission } from '../models/user-permission.enum';
import { PermissionService } from '../services/permission.service';

export const PermissionGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPermissions = route.data['permissions'] as UserPermission[] | undefined;

  if (!requiredPermissions?.length) {
    return true;
  }

  return permissionService.permissions$.pipe(
    take(1),
    map((permissions) => {
      const hasPermission = requiredPermissions.some((permission) => permissions.includes(permission));

      if (hasPermission) {
        return true;
      }

      return new RedirectCommand(router.parseUrl('/access-forbidden'), { skipLocationChange: true });
    })
  );
};
